import Model from "./base/model";

class Company extends Model{
  resourceName() {
    return "companies";
  }

  fields() {
    return {
      social_reason: "",
      fantasy_name:"",
      cnpj: "",
      municipal_registration: "",
      state_registration: "",
      telephone: "",
      type:"",
      two_factor_authentication: "",
      sector_id: "",
      responsible: { jsonApi: "hasOne", type: "users"},
      address: { jsonApi: "hasOne", type: "addresses" },
      company_user_role: "",
      selected_plan: "",
      billing_closing_day: "",
      new_billing_closing_day: "",
      is_annual_plan: "",
      logs: {jsonApi: "hasMany", type: "transporter_logs"},
      documents: {jsonApi: "hasMany", type: "transporter_documents"},
      chat_room_id: "",
      finance_manager_id: "",
      recaptcha: "",
      unread_messages_count: "",
      extra_info: "",
      additional_data: { jsonApi: "hasOne", type: "taker_additional_data" },
      bank_accounts: { jsonApi: "hasMany", type: "bank_accounts" },
      missing_documents: "",
      taker_final_beneficiaries: {jsonApi: "hasMany", type: "taker_final_beneficiaries"},
      extra_address: {jsonApi: "hasOne", type: "addresses"},
      parent_id: "",
      avatar_path: "",
      prospector: { jsonApi: "hasMany", type: "users"},
      code : "",
      receive_notification: "",
    };
  }

  async findMe(){
    return this.request(
      this.resourceName() + "/me",
      "GET"
    );
  }
  async billingClosingDay(id, data) {
    return this.request(
      this.resourceName() + "/billing_closing_day/" + id,
      "PATCH",
      {},
      data
    );
  }
  async setMentor(companyId, data) {
    return this.request(
      this.resourceName() + "/mentor/" + companyId,
      "POST",
      {},
      data,
    )
  }

  async setProspector(companyId, data) {
    return this.request(
      this.resourceName() + "/prospector/" + companyId,
      "POST",
      {},
      data,
    )
  }
}

export default new Company();
